import * as config from './config';
import * as localRunnerCache from './runnerFileCache';
import { Analytics } from '@segment/analytics-node';
import { SEGMENT_CONFIG } from './constants';

// The new flow will set a new key for segment.io as soon as the user will run an execution
// The key will be set in the cache mostly for Testim Connect function that aren't going through services.
// thus cannot get the correct key.

const defaultWriteKey = 'sJOSIGKa5x5rJEGsaOlCjrgozAf7FnVY'; // default write key for US production
let analytics: Analytics | undefined;

export function identify(data: Parameters<Analytics['identify']>[0]) {
    if (config.IS_ON_PREM) {
        return;
    }
    if (!data?.userId) {
        data = { anonymousId: 'runnerId' };
    }
    if (!analytics) {
        localRunnerCache.get(SEGMENT_CONFIG.CACHE_FN_NAME).then(key => {
            analytics = new Analytics({ writeKey: key || defaultWriteKey, flushAt: 1 });
            analytics.identify(data);
        });
        return;
    }
    analytics.identify(data);
}

export function trackWithCIUser(eventName: string, properties?: any) {
    return track('ci', eventName, properties);
}

export function track(userId: string | null | undefined, eventName: string, properties: any) {
    if (config.IS_ON_PREM) {
        return;
    }
    const id = userId ? { userId } : { anonymousId: 'runnerId' };
    if (!analytics) {
        localRunnerCache.get(SEGMENT_CONFIG.CACHE_FN_NAME).then(key => {
            analytics = new Analytics({ writeKey: key || defaultWriteKey, flushAt: 1 });
            analytics?.track(Object.assign(id, {
                event: eventName,
                properties,
            }));
        });
        return;
    }
    analytics.track(Object.assign(id, {
        event: eventName,
        properties,
    }));
}

export function reInitAnalytics(writeKey?: string) {
    if (!writeKey) {
        return;
    }
    analytics = new Analytics({ writeKey, flushAt: 1 });
    localRunnerCache.memoize(
        async () => writeKey,
        SEGMENT_CONFIG.CACHE_FN_NAME,
        SEGMENT_CONFIG.TTL,
        { writeKey },
    )();
}